import { IonPage, IonRouterOutlet, IonSplitPane } from '@ionic/react';
import { ConfigProvider, theme } from 'antd';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { BrowserRouter } from 'react-router';
import Menu from '../components/atoms/Menu/Menu';
import { useAppSelector } from '../store/hooks';
import { selectCurrentLanguage, selectShowMainNav } from '../store/user/userSlice';
import { NavigationContainer } from './NavigationContainer';
import { PublicNavigator } from './PublicNavigator';

export const MainNavigator = () => {
  const showMainNav = useAppSelector(selectShowMainNav);
  const { darkAlgorithm, compactAlgorithm } = theme;
  const currentLanguage = useAppSelector(selectCurrentLanguage);
  const [darkMode, setDarkMode] = useState(false);
  const windowQuery = window.matchMedia('(prefers-color-scheme:dark)');

  const darkModeChange = useCallback((event: MediaQueryListEvent) => {
    setDarkMode(event.matches ? true : false);
  }, []);

  useEffect(() => {
    windowQuery.addEventListener('change', darkModeChange);
    return () => {
      windowQuery.removeEventListener('change', darkModeChange);
    };
  }, [windowQuery, darkModeChange]);

  useEffect(() => {
    setDarkMode(windowQuery.matches ? true : false);
  }, [windowQuery.matches]);

  const mainNav = useMemo(
    () => (
      <IonSplitPane contentId="main">
        <Menu />
        <IonPage id="main">
          <IonRouterOutlet>
            <NavigationContainer />
          </IonRouterOutlet>
        </IonPage>
      </IonSplitPane>
    ),
    [],
  );

  const getNavigation = useCallback(() => {
    return showMainNav ? mainNav : <PublicNavigator />;
  }, [mainNav, showMainNav]);

  return (
    <BrowserRouter>
      <IonRouterOutlet>
        <ConfigProvider
          locale={currentLanguage?.antd}
          theme={{
            algorithm: darkMode ? darkAlgorithm : compactAlgorithm,
          }}>
          {getNavigation()}
        </ConfigProvider>
      </IonRouterOutlet>
    </BrowserRouter>
  );
};
